<template>
  <!--  there are 4 types of banners
    1. Video w/ overlay image (video & overlay image uploaded)
    2. Video w/ normal card (video only uploaded)
    3. Picture w/ overlay image (overlay image uploaded)
    4. Picture w/ normal card (nothing besides the banner picture uploaded)
  phone users will always see the same thing no matter what has been uploaded
  wich is always the normal banner picture and normal card-->

  <div>
    <!--  overlay card for normal format-->
    <v-col class="pa-0" style="position: relative">
      <!-- banner image, video and overlay picture -->
      <v-card :height="bannerHeight" min-height="250" tile flat>
        <!-- banner image-->
        <div v-if="!isMobile && partner.BannerVideoUrl === '' && partner.PortraitBannerVideoUrl === ''">
          <div v-if="partner.BannerPictureUrl === ''">
            <div class="blurEffectImage"
                 :style="{ backgroundImage: `url(${partner.PortraitBannerPictureUrl})`}">
            </div>
            <div>
            <v-img
              contain
              class="bannerImage"
              :height="bannerHeight"
              min-height="250"
              width="100%"
              aspect-ratio="1.618"
              :src="partner.PortraitBannerPictureUrl"
              order="1"
            />
            </div>
          </div>
          <div v-else>
            <div>
              <v-img
                class="bannerImage"
                :height="bannerHeight"
                min-height="250"
                width="100%"
                aspect-ratio="1.618"
                :src="partner.BannerPictureUrl"
                order="1"
              />
            </div>
          </div>
        </div>

        <div v-if="isMobile && partner.BannerVideoUrl === '' && partner.PortraitBannerVideoUrl === ''">
          <div>
            <v-img
              class="bannerImage"
              :height="bannerHeight"
              min-height="250"
              width="100%"
              aspect-ratio="1.618"
              :src="partner.PortraitBannerPictureUrl !== '' ? partner.PortraitBannerPictureUrl : partner.BannerPictureUrl"
              order="1"
            />
          </div>
        </div>

        <!--banner video-->
        <div v-if="!isMobile" class="video-container">
          <video
            muted="true"
            autoplay
            playsinline
            loop
            class="video"
            ref="video"
          >
            <source :src="partner.BannerVideoUrl !== '' ?  partner.BannerVideoUrl : partner.PortraitBannerVideoUrl"/>
          </video>
        </div>

        <div v-if="isMobile" class="video-container">
          <video
            muted="true"
            autoplay
            playsinline
            loop
            class="video"
            ref="video"
          >
            <source  :src="partner.PortraitBannerVideoUrl !== '' ? partner.PortraitBannerVideoUrl : partner.BannerVideoUrl" />
          </video>
        </div>

        <!--overlay image-->
        <v-img :src="partner.BannerOverlayPngUrl" class="overlay-image"></v-img>

        <!-- Button to open info url -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="partner.InfoUrl !== null && partner.InfoUrl !== ''"
              v-bind="attrs"
              v-on="on"
              color="primary"
              class="info-url-btn rounded-pill pa-2 pa-md-6"
              @click.stop="openUrl(partner.InfoUrl)"
            >
              {{ partner.InfoUrlName }}
            </v-btn>
          </template>
          <span>{{ $translate('SHOW_URL') }}</span>
        </v-tooltip>
      </v-card>

      <!-- Info card for small screen, only show title and sub-title.
    Let the title of the Info card overlap with the image. -->
      <v-card
        justify-end
        v-if="breakpointSmAndDown"
        style="position: relative"
        flat
        color="transparent"
      >
        <!-- <div style="min-height: 100px" /> -->
        <v-card flat tile class="text-container overlay-card-small px-4 py-2">
          <v-row class="ma-0">
            <v-col class="pa-0">
              <!-- sub title -->
              <h4
                class="primary-font-color word-break-normal font-weight-regular banner-subtitle-sm"
              >
                {{ partner.BannerSubTitle }}
              </h4>
              <v-col v-if="!userLoggedIn" class="pa-0">
                <v-row class="ma-0">
                  <v-col class="pa-0" cols="8">
                    <!-- title -->
                    <h3
                      class="primary-font-color font-weight-medium banner-title-sm"
                    >
                      {{ partner.BannerPromise }}
                    </h3>
                  </v-col>
                  <v-col class="pa-0 text-right" cols="4">
                    <v-btn
                      depressed
                      dark
                      color="secondary"
                      class="secondary-font-color ma-0 font-weight-bold"
                      @click="emailDialog = true"
                    >
                      <span
                        v-html="$translate('NEWS_LETTER_BUTTON_HTML')"
                      ></span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-else class="pa-0">
                <!-- title -->
                <h3
                  class="primary-font-color font-weight-medium banner-title-sm"
                >
                  {{ partner.BannerPromise }}
                </h3>
              </v-col>
            </v-col>
          </v-row>
        </v-card>
      </v-card>

      <!-- Info card for large screen -->
      <v-card
        v-else-if="!hasOverlayImage"
        class="text-container overlay-card"
        flat
        :width="overlayCardWidth"
      >
        <v-col>
          <!-- title, subtitle, description -->
          <v-card
            color="transparent"
            flat
            :max-height="overlayCardInfoMaxHeight"
            style="overflow: auto"
          >
            <!-- sub title -->
            <div class="primary-font-color banner-subtitle word-break-normal">
              {{ partner.BannerSubTitle }}
            </div>
            <!-- title -->
            <div class="primary-font-color banner-title font-weight-medium">
              {{ partner.BannerPromise }}
            </div>
            <!-- description -->
            <div
              class="primary-font-color banner-description mt-2"
              v-html="partner.BannerDescription"
            ></div>
          </v-card>

          <v-card v-if="!userLoggedIn" color="transparent" flat class="mt-6">
            <v-form ref="form" v-model="valid">
              <v-text-field
                class="pa-0 email-input"
                :rules="emailRules"
                v-model="email"
                dark
                required
                :color="primaryFontColor"
                :label="$translate('LOGIN_YOUR_EMAIL')"
              >
              </v-text-field>
            </v-form>

            <v-row justify="center" class="my-0">
              <v-btn
                depressed
                dark
                color="secondary"
                class="secondary-font-color ma-0 font-weight-bold"
                @click="importInterestedUser"
              >
                {{ $translate('NEWS_LETTER_BUTTON') }}
              </v-btn>
            </v-row>
          </v-card>
        </v-col>
      </v-card>
    </v-col>

    <!-- Email Dialog -->
    <v-dialog v-model="emailDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="text-break">
          {{ $translate('ENTER_YOUR_EMAIL') }}
        </v-card-title>
        <v-card-actions>
          <v-col class="pt-0">
            <v-form class="pb-4" ref="form" v-model="valid">
              <v-text-field
                class="pa-0 email-input-dialog"
                :rules="emailRules"
                v-model="email"
                dark
                required
                :label="$translate('LOGIN_YOUR_EMAIL')"
              >
              </v-text-field>
            </v-form>
            <v-row>
              <v-btn
                elevation="0"
                color="gray"
                class="mb-2 text-capitalize"
                @click="emailDialog = false"
              >
                {{ $translate('CANCEL') }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                elevation="0"
                color="secondary"
                class="mb-2 text-capitalize"
                :disabled="!valid"
                @click="importInterestedUser()"
              >
                {{ $translate('CONTINUE') }}
              </v-btn>
            </v-row>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import utility from '@/shared/utility';
import doRequest from '@/api/dssRequest';
import appConfig from '../../../config/app_config';
import { methods } from '@chenfengyuan/vue-qrcode';

export default {
  name: 'StaticBannerWithCurvedCard',
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    userLoggedIn() {
      return this.$store.getters['auth/isValid'];
    },
    bannerHeightValue() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 30;
        case 'sm':
          return 35;
        case 'md':
          return 60;
        case 'lg':
          return 70;
        case 'xl':
          return 70;
        default:
          return 70;
      }
    },
    bannerHeight() {
      return `${this.bannerHeightValue}vh`;
    },
    overlayCardInfoMaxHeight() {
      const heightValue = this.bannerHeightValue * 0.6;
      return `${heightValue}vh`;
    },
    overlayCardWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'md':
          return '45vw';
        case 'lg':
          return '45vw';
        default:
          return '35vw';
      }
    },
    breakpointSmAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    breakpointMdAndUp() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    hasOverlayImage() {
      return (
        this.partner.BannerOverlayPng != null &&
        this.partner.BannerOverlayPng.trim() !== ''
      );
    },
    primaryFontColor() {
      return this.$store.getters['Account/partnerGroupDetails']
        .PrimaryFontColor;
    },
  },
  data() {
    return {
      partnerHasVideo: true,
      partner: {},
      emailRules: [
        (v) => !!v || this.$translate('EMAIL_REQUIRED'),
        (v) => /.+@.+\..+/.test(v) || this.$translate('EMAIL_VALID'),
      ],
      email: '',
      valid: null,
      overlayImg: '',
      video: '',
      emailDialog: false,
    };
  },
  mounted() {
    this.init();
    this.initPrimaryColorWithOpacity();
    console.log(this.partner)
  },
  methods: {
    init() {
      this.partner = this.$store.getters['Account/partnerGroupDetails'];
   //   this.partner.PortraitBannerVideoUrl = '';
    //  this.partner.BannerVideoUrl = '';
    //   this.partner.BannerPictureUrl = '';
       //this.partner.PortraitBannerPictureUrl = '';
    },
    openUrl(url) {
      const fullUrl = utility.getFullUrl(url);
      window.open(fullUrl);
    },
    importInterestedUser() {
      // check if email field is filled in
      if (!this.$refs.form.validate()) {
        return;
      }
      const payload = {
        Email: this.email,
        client_id: appConfig.Userlogin.clientSecret,
        TempUserId: this.$store.getters['auth/tmpUserId'],
      };
      doRequest(
        (response) => {
          // change the temp user id
          this.$store.commit('auth/setTmpUserId', response.data.UserId);
          this.$refs.form.reset();
          this.emailDialog = false;
          if (response.data.UserExisted) {
            window.EventBus.fire(
              'activateSnackBar',
              this.$translate('NEWSLETTER_ALERT_USEREXISTED')
            );
          } else {
            window.EventBus.fire(
              'activateSnackBar',
              this.$translate('NEWSLETTER_ALERT_SUCCESS')
            );
          }
        },
        () => {
          this.emailDialog = false;
          window.EventBus.fire(
            'activateSnackBar',
            this.$translate('NEWSLETTER_ALERT_ERROR')
          );
        },
        'importInterestedUser',
        this.$store.getters['Account/partnerGroupDetails'].AccountId,
        payload
      );
    },
    initPrimaryColorWithOpacity() {
      /*
      Add opacity to hex color
        r  g  b  a
      # ff ff ff 80;  <-- 80 refers to 50% opacity
      */
      // 80% opacity is used
      const opacityHexValue = 'BF';
      const selector = document.querySelector(':root');
      selector.style.setProperty(
        '--primary-color-opacity',
        `${this.$vuetify.theme.themes.light.primary}${opacityHexValue}`
      );
    },
  },
};
</script>

<style scoped lang="scss">
:root {
  --primary-color-opacity: green;
}
.video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.video-container {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.overlay-image {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  max-height: 100%;
  opacity: 1;
}
.bannerImage {
  position: relative;
  top: 0;
  right: 0;
  @media only screen and (max-width: 1264px) {
    position: relative;
  }
}
.blurEffectImage {
  position: absolute;
  top: 0;
  left: 0;
  background-size: cover;
  filter: blur(14px);
  height: 100%;
  width: 100%;
}
.overlay-card {
  position: absolute;
  // z-index: 1;
  top: 8vh;
  left: 3vw;
}
.overlay-card-small {
  position: absolute;
  bottom: 0vw;
  left: 0vw;
  width: 100%;
}
.info-url-btn {
  position: absolute;
  bottom: 40px;
  right: 50px;
  font-size: 20px;
  @media only screen and (max-width: 960px) {
    top: 10px;
    left: 10px;
    font-size: 14px;
    width: fit-content;
  }
}
.text-container {
  background-color: var(--primary-color-opacity) !important;
}
.banner-title {
  font-size: 25px;
  line-height: 30px;
}
.banner-title-sm {
  font-size: 0.9em;
  line-height: 1.2;
}
.banner-subtitle {
  font-size: 18px;
  line-height: 22px;
}
.banner-subtitle-sm {
  font-size: 18px;
  line-height: 22px;
  margin-bottom: 2px;
}
.banner-description {
  font-size: 14px;
  line-height: 18px;
}
.email-input::v-deep .v-text-field__slot {
  & label {
    color: var(--primary-font-color) !important;
  }
  & input {
    color: var(--primary-font-color) !important;
  }
}
.email-input::v-deep .v-input__slot::before {
  border-color: var(--primary-font-color) !important;
}
.email-input-dialog::v-deep .v-text-field__slot {
  & label {
    color: black !important;
  }
  & input {
    color: black !important;
  }
}
.email-input-dialog::v-deep .v-input__slot::before {
  border-color: black !important;
}
</style>
